module.exports = __webpack_public_path__ + "img/scm03.b6036c35.svg";